import { render } from "./post.html?vue&type=template&id=eac2dd30&ts=true"
import script from "./post.vue?vue&type=script&lang=ts"
export * from "./post.vue?vue&type=script&lang=ts"

import "./post.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\mt7rk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__